/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Drawer, DatePicker, Form, Checkbox } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { 
	COMPLAIN_STATUS
} from '../../constants/lookup'

import OfficerSelect from '../../components/Custom/OfficerSelect'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedOfficer: null
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { selectedComplainAction } = this.props
		if (selectedComplainAction) {
			this.setState({ selectedOfficer: { uid: selectedComplainAction.officer_uid } })
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { selectedOfficer } = this.state
		const { form, AuthStore, saveComplainAction, onClose, complain_uid, selectedComplainAction } = this.props
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const action_date = moment(values.action_date).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values, {
				complain_uid,
				assigned_officer_uid: _.has(selectedOfficer, 'uid') ? selectedOfficer.uid : null,
				action_date
			})
			if (selectedComplainAction) {
				params = Object.assign({}, params, { complain_action_uid: selectedComplainAction.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_brgy_complain_action', content: 'Saving Complain Action, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveComplainAction(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_brgy_complain_action', content: 'Action successfully saved.' })

					//create audit trail
					const auditParams = {
						module_name: 'Complain Action',
						action: 'Create',
						message: 'Created new complain action'
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving barangay complain')
					message.error({ key: 'set_brgy_complain_action', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedComplainAction, AuthStore } = this.props
		const { getFieldDecorator, getFieldValue } = form
		const { barangay_uid, barangay_term_uid } = AuthStore
        
		return (
			<Drawer
				title="Add Action in Complaint"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'60%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row gutter={16}>
						<Col md={16} sm={24}>
							<Form.Item label='Action Taken Form'>
								{ getFieldDecorator('status', {
									initialValue: (selectedComplainAction) ? selectedComplainAction.status : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<Select placeholder='Select Form'>
										{
											COMPLAIN_STATUS.map((i, key) => (
												<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
											))
										}
									</Select>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Date of Action'>
								{ getFieldDecorator('action_date', {
									initialValue: (selectedComplainAction) ? moment(selectedComplainAction.action_date) : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<DatePicker format='LLL' showTime style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
					</Row>
					{/* <Row>
						<Form.Item label='Officer who handle the case'>
							{ getFieldDecorator('assigned_officer_uid', {
								initialValue: (selectedComplainAction) ? selectedComplainAction.officer_name : null,
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<OfficerSelect 
									barangay_uid={barangay_uid}
									barangay_term_uid={barangay_term_uid}
									onSelectedItem={(item) => this.setState({ selectedOfficer: item })}
								/>
							)}
						</Form.Item>
					</Row> */}
					<Row>
						<Form.Item label='Action Remarks'>
							{ getFieldDecorator('action_remarks', {
								initialValue: (selectedComplainAction) ? selectedComplainAction.action_remarks : null,
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input.TextArea rows={4} placeholder='Enter remarks here' />
							)}
						</Form.Item>
					</Row>
					{/* {
						(getFieldValue('status') && (getFieldValue('status') == 'Patalastas sa napiling bubuo ng pangkat')) &&
						<Row>
							<Form.Item label='Lupon Member Name'>
								{ getFieldDecorator('lupon_member_name', {
									initialValue: (selectedComplainAction) ? selectedComplainAction.lupon_member_name : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Lupon member name' />
								)}
							</Form.Item>
						</Row>
					} */}
					{
						(getFieldValue('status') && (getFieldValue('status') == 'Pabatid ng Pagdinig (Conciliation Proceedings)')) &&
						<Row>
							<Form.Item label='Pangkat Chairman'>
								{ getFieldDecorator('lupon_member_name', {
									initialValue: (selectedComplainAction) ? selectedComplainAction.lupon_member_name : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Pangkat Chairman name' />
								)}
							</Form.Item>
						</Row>
					}
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_BARANGAY_COMPLAIN_ACTION = gql`
    mutation setComplainAction($input: JSON) {
		setComplainAction(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-complain-action' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_COMPLAIN_ACTION, {
		props({ mutate }) {
			return {
				saveComplainAction(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayComplains','barangayComplainByUid','barangayComplainActions']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
